var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhysicalActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M182.332,200.572c0,17.87-14.486,32.355-32.35,32.355c-17.873,0-32.359-14.486-32.359-32.355 c0-17.871,14.486-32.357,32.359-32.357C167.846,168.215,182.332,182.701,182.332,200.572z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    stroke: "#BF2117",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M124.204,475.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M175.752,411.703v-162.34h-69.099v0.34c-3.059,0.621-5.982,2.105-8.353,4.479l-83.34,83.333 c-6.427,6.428-6.427,16.845,0,23.265c3.213,3.214,7.422,4.82,11.632,4.82c4.208,0,8.418-1.606,11.631-4.82l68.429-68.423v85.351 h-66.9c-9.086,0-16.452,7.364-16.452,16.452c0,8.778,6.896,15.886,15.553,16.361l73.043,82.312 c3.252,3.662,7.77,5.533,12.313,5.533c3.882,0,7.782-1.369,10.912-4.146c6.799-6.026,7.416-16.426,1.388-23.225l-53.584-60.383 h23.727v1.092H175.752z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M122.013,411.703v-162.34h69.098v0.34c3.059,0.621,5.984,2.105,8.355,4.479l83.339,83.333 c6.426,6.428,6.426,16.845,0,23.265c-3.215,3.214-7.423,4.82-11.632,4.82c-4.211,0-8.419-1.606-11.633-4.82l-68.43-68.423v85.351 h66.899c9.088,0,16.453,7.364,16.453,16.452c0,8.778-6.896,15.886-15.552,16.361l-73.044,82.312 c-3.252,3.662-7.771,5.533-12.314,5.533c-3.88,0-7.782-1.369-10.912-4.146c-6.799-6.026-7.416-16.426-1.388-23.225l53.584-60.383 H191.11v1.092H122.013z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M496.378,27.391c-7.134-7.234-18.515-7.581-25.411-0.775l-91.481,90.209 c-5.643-2.208-11.8-3.448-18.259-3.448c-7.185,0-13.984,1.54-20.127,4.232l-92.272-90.993c-6.896-6.806-18.277-6.459-25.411,0.775 c-7.139,7.239-7.332,18.624-0.431,25.429l92.549,91.264c-1.979,5.128-3.117,10.658-3.117,16.454V272.16 c0,1.929,0.155,3.821,0.394,5.688c-0.244,1.084-0.394,2.192-0.394,3.336v163.423c0,9.691,9.081,17.551,20.282,17.551 c11.209,0,20.296-7.859,20.296-17.551V318.603c2.68,0.443,5.417,0.719,8.231,0.719c2.81,0,5.547-0.275,8.227-0.719v126.004 c0,9.691,9.08,17.551,20.281,17.551c11.209,0,20.297-7.859,20.297-17.551V281.184c0-1.14-0.148-2.252-0.387-3.333 c0.231-1.869,0.387-3.758,0.387-5.69V160.538c0-6.514-1.37-12.717-3.838-18.359l90.615-89.358 C503.71,46.015,503.517,34.63,496.378,27.391z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M392.254,64.735c0,17.869-14.484,32.354-32.351,32.354c-17.873,0-32.358-14.486-32.358-32.354 c0-17.872,14.485-32.358,32.358-32.358C377.77,32.377,392.254,46.863,392.254,64.735z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalActivity);
export default __webpack_public_path__ + "static/media/physical_activity.d23d92e3.svg";
export { ForwardRef as ReactComponent };